import { useQuery } from "@tanstack/react-query";
import { getPlanDetails } from "../api/planner";

export const usePlanDetails = (planId: string) => {
    return useQuery({
        queryKey: ["plan", planId],
        queryFn: () => getPlanDetails(planId),
        enabled: !!planId,
    });
};
